import React from 'react';
import { useFormikContext } from 'formik';
import styled from 'styled-components';
import { Button, Colors } from '@inplayer-org/inplayer-ui';

// constants
import Rules from 'restrictions/roles/constants/rules';

// utils
import { snakeCase } from 'lodash';

// components
import RestrictedByRule from 'restrictions/roles/components/RestrictedByRule';
import ButtonTooltip from './ButtonTooltip';

const FooterWrapper = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${Colors.white};
  padding: 1.5rem 6%;
  border-top: 1px solid ${Colors.gray};
  box-shadow: 0 1px 15px ${Colors.gray};
  height: fit-content;
  margin-top: auto;
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledButton = styled(Button)`
  width: 20%;
`;

type ButtonType = 'submit' | 'button';

interface OwnProps {
  handleCancel?: () => void;
  disabled?: boolean;
  form?: string;
  onFormSubmit?: () => any;
  showSaveButton?: boolean;
  buttonType?: ButtonType;
  buttonTooltipContent?: string;
  accordionLabel?: string;
}

type Props = OwnProps;

const AccordionFooter = ({
  handleCancel,
  disabled,
  form,
  buttonType = 'submit',
  onFormSubmit,
  showSaveButton = true,
  buttonTooltipContent,
  accordionLabel = '',
}: Props) => {
  const formikContextValues = useFormikContext();

  const { isValid, isSubmitting, dirty } = formikContextValues || {};

  const isDisabled = disabled ?? (!formikContextValues && false) ?? (!isValid || isSubmitting || !dirty);

  return (
    <FooterWrapper>
      <FooterContainer>
        <StyledButton
          tag={`button_cancel_${snakeCase(accordionLabel)}`}
          buttonModifiers={['buttonLink']}
          type="button"
          onClick={handleCancel}
          size="md"
        >
          Cancel
        </StyledButton>
        {showSaveButton && (
          <RestrictedByRule rule={Rules.READONLY_ASSETS_AND_PACKAGES}>
            <ButtonTooltip content={buttonTooltipContent}>
              <StyledButton
                tag={`button_save_${snakeCase(accordionLabel)}`}
                form={form}
                type={buttonType}
                size="md"
                buttonModifiers={['buttonPrimary']}
                disabled={isDisabled}
                onClick={onFormSubmit}
              >
                Save
              </StyledButton>
            </ButtonTooltip>
          </RestrictedByRule>
        )}
      </FooterContainer>
    </FooterWrapper>
  );
};

export default AccordionFooter;
